import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, ToastController, NavParams, AlertController, ViewController } from 'ionic-angular';
import { RestProvider } from '../../providers/rest/rest';
import { HttpClient} from '@angular/common/http';
import { DataProvider } from '../../providers/data/data';

@IonicPage()
@Component({
  selector: 'page-connectCompany',
  templateUrl: 'connectCompany.html',
})
export class connectCompanyPage {
  private projects = [];
  private work: any;
  private tasks = [];
  private desc: any;
  private title: any;
  config1: any;
  private GetCustomers =[];
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public alertCtrl: AlertController,
    private rest: RestProvider,
    private data: DataProvider,
    private toastCtrl: ToastController,
    public httpClient: HttpClient,
    ) {

      this.config1 = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: this.projects.length
      };
  }
  pageChanged(event){
    this.config1.currentPage = event;
  }
  ionViewDidLoad() {
    document.getElementById('backmenu').style.display = 'block';
    document.getElementById('backFrom').innerText = '';
    this.data.currentTabName = 'Харилцагч Компанийн мэдээлэл';
    this.getProject();

  }

  getProject(){
    this.rest.GetCustomers().subscribe(res => {
      this.GetCustomers = res;
    });
  }
  closeProject(work: any){
    if(confirm('Та тухайн Компанийн мэдээллийг хаахдаа итгэлтэй байна уу?')) {
      this.rest.setCustomers(work.id, work.customer_name, work.customer_zName, work.customer_begin_day, work.customer_phone, work.customer_email, work.customer_address, "asdf", "del", true).subscribe(res => {
        this.showToast('Таны сонгосон Компанийн мэдээллийг амжилттай хаагдлаа.');
        this.getProject();
      });
    }
  }

  addProject(work: any){
    let addProject = this.modalCtrl.create(
      ModalAddProjectPage,
      { work: work },
      {
        showBackdrop: false,
        enableBackdropDismiss: true
      }
    );
    addProject.present().catch(err => {

    });
    addProject.onDidDismiss((data) => {
      if(data != null) {
        this.getProject();
      }
    });
  }
  showToast(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-success"
    });
    toast.present();
  }
  showToast1(str: any) {
    let toast = this.toastCtrl.create({
      message: str,
      position: 'middle',
      duration: 5000,
      cssClass: "toast-unsuccess"
    });
    toast.present();
  }
}
  @Component({
    template: `
    <ion-header text-center style="height: 50px; background-color: #84dac8;">
      <ion-title>Харилцагч компани нэмэх</ion-title>
    </ion-header>
    <ion-content text-center>
      <ion-grid>

      <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item >
            <ion-label floating >Харилцагч Компанийн нэр</ion-label>
            <ion-textarea [(ngModel)]="cname"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item >
            <ion-label floating >Захирлын нэр</ion-label>
            <ion-textarea [(ngModel)]="zname"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
      <ion-item>
        <ion-label>Харилцагч болсон огноо</ion-label>
        <ion-datetime displayFormat="YYYY/MM/DD" [(ngModel)]="beginDay"></ion-datetime>
    </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>

  <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Холбоо барих утасны дугаар</ion-label>
            <ion-textarea [(ngModel)]="phone"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

   <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>И-мэйл хаяг</ion-label>
            <ion-textarea [(ngModel)]="email"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

   <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Хаяг</ion-label>
            <ion-textarea [(ngModel)]="address"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

   <ion-row *ngIf="is_end == 1">
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
        <ion-list radio-group [(ngModel)]="isEnd">
          <ion-item>
            <ion-label>Сэргээх</ion-label>
            <ion-radio value="1"></ion-radio>
          </ion-item>
          <ion-item>
            <ion-label>Сэргээхгүй</ion-label>
            <ion-radio value="0" checked="true"></ion-radio>
          </ion-item>
        </ion-list>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>

   <ion-row>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
        <ion-col text-center col-sm-6 col-xl-6 col-md-6 col-lg-6>
            <ion-item>
            <ion-label floating>Коммент</ion-label>
            <ion-textarea [(ngModel)]="desc"></ion-textarea>
          </ion-item>
        </ion-col>
        <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
          </ion-col>
   </ion-row>



  <ion-row>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
        <button full class="myButton" (click)="AddCustomers()" *ngIf="work == null">Үүсгэх</button>
        <button full class="myButton" (click)="setCompany()" *ngIf="work != null">Засах</button>
      </ion-item>
    </ion-col>
    <ion-col text-center col-sm-3 col-xl-3 col-md-3 col-lg-3>
      <ion-item>
        <button full class="myButton" (click)="backto()">Буцах</button>
      </ion-item>
    </ion-col>
    <ion-col col-sm-3 col-xl-3 col-md-3 col-lg-3>
    </ion-col>
  </ion-row>
  </ion-grid>
  </ion-content>
    `
  })

  export class  ModalAddProjectPage {
    private workId: any;
    private companyId: any;
    private id: any;
    private title: any;
    private beginDay: any;
    private endDay: any;
    private usageTime: any;
    private spendTime: any;
    private spendProcess: any;
    private createdUserId: any;
    private customerId: any;
    private projectMembersIds: any;
    private userId: any;
    private GetCmbUser = [];
    private GetCustomers = [];
    private addProject: any;
    private setCustomer: any;
    private projectMembersId = '';
    private work: any;
    private cname: any;
    private zname: any;
    private address: any;
    private email: any;
    private desc: any;
    private phone: any;
    private is_end = 0;
    public isEnd = "0";

    constructor(public navCtrl: NavController,
      public navParams: NavParams,
      public alertCtrl: AlertController,
      private rest: RestProvider,
      public httpClient: HttpClient,
      private viewCtrl: ViewController,
      private toastCtrl: ToastController,
      private data: DataProvider,){
        this.work = this.navParams.get('work');
        if(this.work != null) {
          this.cname = this.work.customer_name;
          this.zname = this.work.customer_zName;
          this.beginDay = this.work.customer_begin_day;
          this.phone = this.work.customer_phone;
          this.email = this.work.customer_email;
          this.address = this.work.customer_address;
          this.desc = this.work.customer_comment;
          this.id = this.work.id;
          this.is_end = this.work.is_end;
        }
    }


    AddCustomers(){
      if( !this.cname ){
        this.cname == null;
        this.showToast1('Харилцагч компанийн талбар хоосон байна!!!');
        return;
      }
      if( !this.zname ){
        this.zname == null;
        this.showToast1('Захирлын нэр  талбар хоосон байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Харилцагч болсон огноо сонгогдоогүй байна!!!');
        return;
      }
      if( !this.phone ){
        this.phone == null;
        this.showToast1('Холбоо барих утас бичигдээгүй байна!!!');
        return;
      }
      if( !this.email ){
        this.email == null;
        this.showToast1('И-мэйл хаяг бичигдээгүй байна!!!');
        return;
      }
      if( !this.address ){
        this.address == null;
        this.showToast1('Харилцагч компанийн хаяг бичигдээгүй байна!!!');
        return;
      }
      this.rest.setCustomers("", this.cname, this.zname, this.beginDay, this.phone, this.email, this.address,this.desc, "", false).subscribe(res => {
        this.addProject = res;
        if(res.msg == null) {
          this.showToast1('Та компанийн мэдээллээ бүрэн оруулна уу.');
        } else if(res.msg == 'ok') {
          this.showToast('Компани амжилттай нэмэгдлээ.');
          this.viewCtrl.dismiss({data: 'edit'});
        }
      });
    }

    setCompany(){
      if( !this.cname ){
        this.cname == null;
        this.showToast1('Харилцагч компанийн талбар хоосон байна!!!');
        return;
      }
      if( !this.zname ){
        this.zname == null;
        this.showToast1('Захирлын нэр  талбар хоосон байна!!!');
        return;
      }
      if( !this.beginDay ){
        this.beginDay == null;
        this.showToast1('Харилцагч болсон огноо сонгогдоогүй байна!!!');
        return;
      }
      if( !this.phone ){
        this.phone == null;
        this.showToast1('Холбоо барих утас бичигдээгүй байна!!!');
        return;
      }
      if( !this.email ){
        this.email == null;
        this.showToast1('И-мэйл хаяг бичигдээгүй байна!!!');
        return;
      }
      if( !this.address ){
        this.address == null;
        this.showToast1('Харилцагч компанийн хаяг бичигдээгүй байна!!!');
        return;
      }
      let end = "";
      if(this.isEnd == "1" && this.is_end == 1) {
        end = 'upd';
      }
      this.rest.setCustomers(this.id, this.cname, this.zname, this.beginDay, this.phone, this.email, this.address,this.desc, end, true).subscribe(res => {
        this.setCustomer = res;
        if(res.msg == null) {
          this.showToast1('Та компанийн мэдээллээ бүрэн оруулна уу.');
        } else if(res.msg == 'ok') {
          this.showToast('Компани амжилттай засагдлаа.');
          this.viewCtrl.dismiss({data: 'edit'});
        }
      });
    }

    backto(){
      this.viewCtrl.dismiss({});
    }

    showToast(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-success"
      });
      toast.present();
    }
    showToast1(str: any) {
      let toast = this.toastCtrl.create({
        message: str,
        position: 'middle',
        duration: 5000,
        cssClass: "toast-unsuccess"
      });
      toast.present();
    }
  }



// WEBPACK FOOTER //
// ./src/pages/connectCompany/connectCompany.ts